import { baseApi } from "./baseApi";

const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLenderUsers: builder.query({
      query: () => ({
        url: "/users/lender",
        method: "GET",
      }),
      providesTags: ["LenderUsers"],
    }),

    inviteLenderAdmin: builder.mutation({
      query: (body) => ({
        url: "/users/invite",
        method: "POST",
        body,
      }),
      invalidatesTags: ["LenderUsers"],
    }),

    deleteLenderUser: builder.mutation({
      query: ({ userId }) => ({
        url: `/users/${userId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["LenderUsers"],
    }),

    resendLenderUserConfirmation: builder.mutation({
      query: ({ userId }) => ({
        url: `/users/${userId}/resend-confirmation`,
        method: "POST",
      }),
    }),
  }),
});

export default userApi;
